import { createSlice } from '@reduxjs/toolkit';

import asyncThunks from './async-thunks';
import extraReducers from './extra-reducers';
import { ExportState } from './types';

const initialState: ExportState = {
  currentCustomerGroupUuid: '',
  host: '',
  isError: false,
  isLoading: false,
};

const slice = createSlice({
  extraReducers: (builder) => {
    extraReducers.requestExport(builder);
  },
  initialState,
  name: 'api',
  reducers: {
    setCurrentCustomerGroupUuid: (state, action) => {
      state.currentCustomerGroupUuid = action.payload;
    },
    setHost: (state, action) => {
      state.host = action.payload;
    },
  },
});

const api = {
  reducer: slice.reducer,
  requestExport: asyncThunks.requestExport,
  setCurrentCustomerGroupUuid: slice.actions.setCurrentCustomerGroupUuid,
  setHost: slice.actions.setHost,
};

export default api;
